import { AxiosResponse } from "axios"
import $api from "../../../axios"
import {
  IGetSbTargetBody,
  ISbTargetResult,
  IUpdateSpTargetParams,
} from "../types/sbTargetApi.types"

class SbTargetApi {
  url: string

  constructor() {
    this.url = "/SB/target"
  }

  async getTargetData(data: IGetSbTargetBody): Promise<AxiosResponse<ISbTargetResult[]>> {
    return $api.post(`${this.url}/getTargetData`, data)
  }

  async updateSbTarget(data: IUpdateSpTargetParams): Promise<AxiosResponse<any>> {
    return $api.post(`${this.url}/updateSBTarget`, data)
  }
}

export default new SbTargetApi()
